import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

import presets, { colors, animation, buttonReset } from '../utils/presets';
import { toRem } from '../utils/functions';

const { curve, speed } = animation;

const widths = {
  long: toRem(presets.baselineGrid * 4),
  medium: toRem(presets.baselineGrid * 3),
  short: toRem(presets.baselineGrid * 2.5),
  active: toRem(27),
};

const menuToggle = css({
  ...buttonReset,
  position: 'relative',
  width: toRem(presets.baselineGrid * 4),
  height: toRem(presets.baselineGrid * 3),
  cursor: 'pointer',
});

const menuToggleInner = css`
  display: block;
  position: absolute;
  width: ${widths.long};
  height: 3px;
  top: 50%;
  right: 0;
  margin-top: -1px;
  transition: width ${speed.default} ${curve.easeInOutCirc},
    transform ${speed.default} ${curve.easeInOutCirc};
  transform-origin: center;

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: ${widths.medium};
    height: 3px;
    right: 0;
    background-color: inherit;
    transform-origin: center;
    transition: transform ${speed.default} ${curve.easeInOutCirc},
      opacity ${speed.default} ${curve.easeInOutCirc}, width ${speed.default} ${curve.easeInOutCirc};
    transition-delay: 80ms;
  }

  &::before {
    transform: translateY(-7px);
  }

  &::after {
    transform: translateY(7px);
  }

  .menu-open & {
    width: ${widths.active};
    transform: rotate(-225deg);

    &::before {
      opacity: 0;
      width: ${widths.active};
      transform: translateY(0);
    }

    &::after {
      width: ${widths.active};
      transform: rotate(-90deg) translateY(0);
    }
  }
`;

const MenuToggle = ({ color, onClick, label, styles }) => (
  <button
    css={`
      ${menuToggle};
      ${styles};
    `}
    onClick={onClick}
    aria-label={label}
    aria-expanded="false"
  >
    <span
      css={`
        ${menuToggleInner};
        background-color: ${color};
      `}
    />
  </button>
);

MenuToggle.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  styles: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

MenuToggle.defaultProps = {
  color: colors.gray.copy,
  label: 'Navigation Menu',
};

export default MenuToggle;



// WEBPACK FOOTER //
// ./src/components/menu-toggle.js